// Initializing State
export const initialStoreState = {
  coordinates: {},
  user: null,
  loader: false,
  originalPoint: {},
  originalPointVehicle: {},
  originalFlight: {},
  customerDetails: {},
  cardInfo: {},
  passengerInformation: {},
  paymentInformation: {},
  totalPrice: {},
  totalCost: {},
  returnReservation: {},
  returnPointVehicle: {},
  returnFlight: {},
  totalCostOriginal: {},
  returnTotalCost: {},
  totalCostOriginal: "0.00",
  totalCostReturn: "0.00",
  promoCodeValue: "0",
  promoCodeValueReturn: "0",
  promoCodeType: "",
};

export const accountStore = {
  token: null,
  account: null,
  accountId: null,
  accountNumber: null,
  accountStatus: 'login',
};
